export const navItems = [
  {
    id: "1",
    name: "people"
  },
  {
    id: "2",
    name: "starships"
  },
  {
    id: "3",
    name: "vehicles"
  },
  {
    id: "4",
    name: "species"
  },
  {
    id: "5",
    name: "planets"
  }
];
